/**
 * @file guid Generate pseudo GUID
 * @author yuzong(yuzong@tencent.com)
 */
import { rand } from './rand';
/**
 * Generate pseudo GUID
 *
 * @param sp Separator of GUID, `-` by default.
 */

export function guid() {
  var sp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
  return rand(4) + rand(4) + sp + rand(4) + sp + rand(4) + sp + rand(4) + sp + rand(4) + rand(4) + rand(4);
}